<template>
    <div class="text-center">
      <v-overlay :value="loading" style="z-index: 9999">
        <v-progress-circular
          :size="64"
          color="#2196f3"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        name: 'Loading',
        data: () => ({

        }),
        computed: {
            ...mapState(['loading'])
        }
    }
</script>